const FIELD_RULES = {
  1: {},
  2: {},
  3: {},
  4: {},
  5: { numeric: true },
  6: { decimal: true },
  7: { date_format: 'DD/MM/YYYY' },
  8: {},
  9: {},
  10: {},
  11: {},
  12: {},
  13: {},
  14: {},
  15: {},
  16: {},
  17: {},
  18: {},
  19: { email: true },
  20: {},
  21: {},
  22: {},
  25: {}
}

const FIELD_TYPES = {
  1: 'TextField',
  2: 'MultitextField',
  3: 'ListField',
  4: 'SelectField',
  5: 'NumberField',
  6: 'DecimalField',
  7: 'DateField',
  8: 'RequesterField',
  9: 'ProductServiceField',
  10: 'TypeField',
  11: 'PriorityField',
  13: 'SubjectCategoryField',
  14: 'TagsField',
  20: 'DescriptionField',
  21: 'ForwardingField',
  22: 'UserProductServiceField',
  25: 'SearchableList'
}

export const getFieldRules = () => FIELD_RULES

export const getFieldTypes = () => FIELD_TYPES
